// ABSOLUTE IMPORTS
import { useFeatureFlags } from 'components/hooks/useFeatureFlags'
import Footer from 'components/browse/skeletonLoaders/MainLayout/Footer'
import Header from 'components/browse/skeletonLoaders/MainLayout/Header'
import HeaderV2 from 'components/browse/skeletonLoaders/MainLayout/HeaderV2'

type HeaderVariantFlags = {
  releaseLibraryBrandingCustomization: boolean
}

const MainLayoutSkeletonLoader = () => {
  const { getFlag } = useFeatureFlags<HeaderVariantFlags>()
  const releaseLibraryBrandingCustomization = getFlag(
    'releaseLibraryBrandingCustomization',
  ) as boolean

  const SkeletonHeader = () =>
    releaseLibraryBrandingCustomization ? <HeaderV2 /> : <Header />

  return (
    <div className="flex h-full flex-col">
      <SkeletonHeader />
      <div className="mx-auto h-full w-[calc(100%-3rem)] md:max-w-245 lg:w-full" />
      <Footer />
    </div>
  )
}

export default MainLayoutSkeletonLoader
